import { render, staticRenderFns } from "./CreateL2NetworkForm.vue?vue&type=template&id=2abf4f04&scoped=true&"
import script from "./CreateL2NetworkForm.vue?vue&type=script&lang=js&"
export * from "./CreateL2NetworkForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateL2NetworkForm.vue?vue&type=style&index=0&id=2abf4f04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf4f04",
  null
  
)

export default component.exports